import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(...inputs))
}

// Drop-in for the `clx` helper from @medusajs/ui, which is also
// twMerge(clsx(...)). Kept as a separate name so call sites read the same
// after the migration from @medusajs/ui.
export function clx(...inputs: ClassValue[]) {
  return twMerge(clsx(...inputs))
}
